import { z as zod } from 'zod'

export const optionalEmailSchema = zod.preprocess(
  (value) => (typeof value === 'string' ? value.trim() : value),
  zod.union([
    zod.literal(''),
    zod.string().email({ message: 'Email not valid' }).max(256, { message: 'Email too long' })
  ])
)

const addUserValidationSchema = zod.object({
  name: zod
    .string()
    .min(1, { message: 'Name is required' })
    .min(5, { message: 'Name not valid, minimum 5 characters' })
    .regex(/^[A-Za-zÀ-ÖØ-öø-ÿ'-]+(?: [A-Za-zÀ-ÖØ-öø-ÿ'-]+)*\s*$/i, `Name not valid`) //only letters, dashes, aphostrophes allowed, one at a time
    .max(100, { message: 'Name to long' }),
  username: zod
    .string()
    .min(1, { message: 'Username is required' })
    .min(3, { message: 'Username not valid, minimum 3 characters' })
    .regex(
      /^[a-z][a-z0-9_]*$/,
      'Username not valid, must be lowercase, may use underscore and/or numbers'
    ) //only lowercase letters, _, and numbers allowed, pattern: 'username' or 'username1' or 'username_1'
    .max(30, { message: 'Username to long' }),
  email: optionalEmailSchema
})

export default addUserValidationSchema
